import React, { useState } from 'react'
import {
    MDBNavbar, MDBNavbarBrand,MDBAlert,MDBContainer, MDBFooter,MDBNavbarNav, MDBIcon,MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBFormInline,
    MDBDropdown, MDBDropdownToggle, MDBDropdownMenu,MDBSideNav, MDBDropdownItem
    } from "mdbreact";
import { BrowserRouter as Router,Link } from 'react-router-dom';
import Routes from '../../routes/routes';
import { connect } from 'react-redux'
import SignedInLinks from '../../authentication/auth/signedInlinks'
import SignedOutLinks from '../../authentication/auth/signedoutLinks'

function Navbar(props) {
  const { auth, profile } = props;
  const links = auth.uid ? <SignedInLinks {...auth} /> : <SignedOutLinks /> ;
  const [open, setopen] = useState(false)
  const toggler =() => { setopen(!open) }
    return (
        <div>
            <Router>
            <MDBNavbar color="unique-color-dark" className="scrolling-navbar  fixed-top" dark expand="md">
      <MDBNavbarBrand href="#">
          <img src="http://www.visakhadairy.com/images/logo.png" height="80" alt=""  />
        </MDBNavbarBrand>
        <MDBNavbarToggler onClick={toggler}/>
        <MDBCollapse id="navbarCollapse3" isOpen={open} navbar>
          <MDBNavbarNav left>
            <MDBNavItem active>
              <MDBNavLink to="/">Home</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <span className="mr-2 ">Management</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu className="dropdown-content ">
                  <MDBNavLink  className="nav-link black-text" to="/aboutChairman">Chairman</MDBNavLink>
                  <MDBNavLink  className="nav-link black-text" to="/boardMembers">Board of directors</MDBNavLink> 
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
            <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <span className="mr-2">location</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu className="dropdown-content">
                 <MDBNavLink  className="nav-link black-text" to="/parlourOutlet">Parlour Outlet</MDBNavLink> 
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
            <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <span className="mr-2">Products</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu className="">
                  <MDBNavLink  className="nav-link black-text" to="/milkProducts">Milk</MDBNavLink> 
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
            <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <span className="mr-2">Media</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu>
                  <MDBNavLink  className="nav-link black-text" to="#!">Photos</MDBNavLink> 
                  <MDBNavLink  className="nav-link black-text" to="#!">Videos</MDBNavLink> 
                  <MDBNavLink  className="nav-link black-text" to="#!">Press Release</MDBNavLink> 
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
            <MDBNavItem>
              <MDBNavLink to="/carrers">Carrers</MDBNavLink>
            </MDBNavItem>
          </MDBNavbarNav>
          <MDBNavbarNav right>
            <MDBNavItem>
              <MDBNavLink className="waves-effect waves-light" to="#!">
                <MDBIcon fab icon="twitter" />
              </MDBNavLink>
            </MDBNavItem>
            <MDBNavItem>
              <MDBNavLink className="waves-effect waves-light" to="#!">
                <MDBIcon fab icon="google-plus-g" />
              </MDBNavLink>
            </MDBNavItem>
            {links}
          </MDBNavbarNav>
        </MDBCollapse>
      </MDBNavbar>
    
                <Routes/>
            </Router>
        
        </div>
    )
}

const mapStateToProps = (state) =>{
  console.log(state)
  return{
      auth: state.firebase.auth,
      profile: state.firebase.users
  }
}
export default connect (mapStateToProps)(Navbar);
